import { z } from 'zod';

/** Contrato do Dashboard (M4). Payload único agregado para o mês. */

const ymSchema = z.string().regex(/^\d{4}-\d{2}$/);

export const categorySliceSchema = z.object({
  categoryId: z.string(),
  name: z.string(),
  color: z.string(),
  icon: z.string(),
  totalCents: z.number().int(),
});
export type CategorySlice = z.infer<typeof categorySliceSchema>;

export const monthPointSchema = z.object({
  month: ymSchema,
  balanceCents: z.number().int(),
});
export type MonthPoint = z.infer<typeof monthPointSchema>;

export const incomeExpensePointSchema = z.object({
  month: ymSchema,
  incomeCents: z.number().int(),
  expenseCents: z.number().int(),
});
export type IncomeExpensePoint = z.infer<typeof incomeExpensePointSchema>;

export const dashboardAccountSchema = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string(),
  icon: z.string().nullable(),
  currentCents: z.number().int(),
  predictedCents: z.number().int(),
});
export type DashboardAccount = z.infer<typeof dashboardAccountSchema>;

export const dashboardResponseSchema = z.object({
  month: ymSchema,
  balance: z.object({
    currentCents: z.number().int(),
    predictedCents: z.number().int(),
  }),
  totals: z.object({
    incomeCents: z.number().int(),
    expenseCents: z.number().int(),
    pendingIncomeCents: z.number().int(),
    pendingExpenseCents: z.number().int(),
  }),
  /** Σ das faturas com vencimento neste mês (motor de faturas — 0 antes do M5). */
  cardsDueCents: z.number().int(),
  /** Despesas por categoria (pai soma filhos), maiores primeiro. */
  expensesByCategory: z.array(categorySliceSchema),
  /** Saldo consolidado dos últimos 6 meses (para o gráfico de linha). */
  balanceHistory: z.array(monthPointSchema),
  /** Receitas × despesas dos últimos 3 meses (barras agrupadas). */
  incomeVsExpense: z.array(incomeExpensePointSchema),
  /** (receitas − despesas) / receitas × 100 do mês. */
  savingsPercent: z.number(),
  accounts: z.array(dashboardAccountSchema),
});
export type DashboardResponse = z.infer<typeof dashboardResponseSchema>;
